<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Externe Registrierung</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>Funktionalität</col-label>
          <div class="col-8">
            <div class="custom-control">
              <div class="my-1">
                <toggle-switch
                  label="Registrierungsprozess für externe zulassen"
                  type="success"
                  v-model="data.accessControlAllowOriginEnabled"
                >
                </toggle-switch>
              </div>
              <div class="my-1">
                <toggle-switch
                  v-if="data.accessControlAllowOriginEnabled"
                  label="Alle zulassen (nein) oder Nur von der Liste (ja)"
                  type="success"
                  v-model="data.accessControlAllowOriginUseList"
                >
                </toggle-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="col-11">
        <v-button @click="persistSettings()" class="btn btn-primary float-right"
          >Speichern</v-button
        >
      </div>
    </div>

    <div v-if="listEnabled">
      <div>
        <v-button
          @click.native="$modal.show(createAllowOriginModalName)"
          class="btn btn-primary"
          >Domain zugelassenen</v-button
        >
      </div>
      <v-table
        url="/api/v1/accessControlAllowOrigin"
        :attributes="[
          {
            attribute: 'domain',
            name: 'Domain'
          },
          {
            attribute: 'created_at',
            name: 'angelegt am'
          },
          {
            name: 'Aktionen',
            type: 'ExternRegistrationActionCell'
          }
        ]"
        ref="table"
      >
        <div slot="title">
          <h4>Zugelassene Domains</h4>
        </div>
      </v-table>
    </div>

    <modal
      :name="createAllowOriginModalName"
      :maxWidth="600"
      width="90%"
      height="auto"
      :adaptive="true"
      style="overflow: hidden"
    >
      <section class="p-3">
        <div class="form-group">
          <textarea
            class="form-control"
            placeholder="domain.test"
            v-model="domain"
          ></textarea>
        </div>
        <button
          @click="createAllowedDomain()"
          type="button"
          class="btn btn-primary"
        >
          Speichern
        </button>
      </section>
    </modal>
  </section>
</template>

<script>
import PSwitch from "src/components/UIComponents/Switch.vue";

export default {
  components: {
    PSwitch
  },
  data() {
    return {
      data: {
        accessControlAllowOriginEnabled: false,
        accessControlAllowOriginUseList: false
      },
      domain: ""
    };
  },
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
      // Typecasting 'accessControlAllowOriginEnabled / .UseList' to boolean
      this.data.accessControlAllowOriginEnabled = !!+this.data
        .accessControlAllowOriginEnabled;
      this.data.accessControlAllowOriginUseList = !!+this.data
        .accessControlAllowOriginUseList;
    });
  },
  computed: {
    listEnabled() {
      return (
        this.data.accessControlAllowOriginUseList &&
        this.data.accessControlAllowOriginEnabled
      );
    },
    createAllowOriginModalName() {
      return "create-access-control-allow-origin-modal";
    }
  },
  methods: {
    persistSettings() {
      if (!this.data.accessControlAllowOriginEnabled) {
        this.data.accessControlAllowOriginUseList = false;
      }
      const corsSettings = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", corsSettings).then(() => {
        this.$notify({
          title: "Externe-Registrierung Einstellungen gespeichert",
          type: "success"
        });
      });
    },
    createAllowedDomain() {
      this.disableModalActions = true;
      this.$http
        .post("/api/v1/accessControlAllowOrigin/", {
          domain: this.domain
        })
        .then(() => {
          this.$modal.hide(this.createAllowOriginModalName);
          this.$notify({
            title: "Zugelassene Domain wurde gespeichert",
            type: "success"
          });
          this.$bus.$emit("refresh-table", this.$refs.table.id);
        })
        .finally(() => {
          this.disableModalActions = false;
          this.domain = "";
        });
    }
  }
};
</script>
